module.exports = __webpack_public_path__ + "img/annotation4.2c9153a2.svg";